import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'
import _ from 'lodash'

export default class extends Controller {
  static targets = ["Input", "results"]

  connect() {
    this.element[this.identifier] = this
    this.timeout = null
    this.results = []

    this.InputTarget.addEventListener('keyup', this.onInputKeyup.bind(this))
    this.InputTarget.addEventListener('focus', this.onInputFocus.bind(this))
    this.InputTarget.addEventListener('keydown', this.preventSubmit.bind(this))
  }

  get parentFormController() {
    var elem = document.querySelector(`[data-controller="${this.element.dataset.formControllerName}"]`)
    return this.application.getControllerForElementAndIdentifier(elem, this.element.dataset.formControllerName)
  }

  preventSubmit(e) {
    // disable enter key which submits the parent form
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  search(e) {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(async () => {
      const url = `${this.element.dataset.searchUrl}?query=${e.target.value}`
      const request = new FetchRequest('GET', url, { responseKind: 'json' } )
      const response = await request.perform()

      if (response.ok) {
        let responseJson = await response.json
        this.results = responseJson
        this.resultsTarget.innerHTML = ""
        if (responseJson.length == 0) {
          let elem = document.createElement("li")
          elem.classList.add("p-1", "w-full", "hover:bg-gray-200", "focus:bg-gray-300", "cursor-pointer")
          elem.innerHTML = `No results...`
          this.resultsTarget.appendChild(elem)
        } else {
          responseJson.map((item) => {
            let elem = document.createElement("li")
            elem.classList.add("p-1", "w-full", "hover:bg-gray-200", "focus:bg-gray-300", "cursor-pointer")
            let compiled = _.template(this.element.dataset.itemFormat.replace("${", "<%=").replace("}", "%>"))
            elem.innerHTML = compiled(item)
            elem.value = item.id
            elem.dataset.action = `click->${this.element.dataset.controller}#onItemClick`
            elem.dataset.resourceJson = JSON.stringify(item)
            this.resultsTarget.appendChild(elem)
          })
        }
        this.resultsTarget.classList.remove("hidden")
      }
    }, 200)
  }

  itemTemplate(strings, ...keys) {
    return (function(...values) {
      let dict = values[values.lenght - 1] || {}
      let result = [strings[0]]
      keys.forEach(function(key, i) {
        let value = Number.isInteger(key) ? values[key] : dict[key]
        result.push(value, strings[i + 1])
      })
      return result.join('')
    })
  }

  showResults() {
    if (this.results.length > 0) {
      this.resultsTarget.classList.remove("hidden")
    }
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden")
  }

  onItemClick(e) {
    let resourceJson = JSON.parse(e.target.dataset.resourceJson)
    this.parentFormController.onFillData(resourceJson, this.element.dataset.formResourceType)
    this.InputTarget.value = e.target.innerHTML
  }

  onInputKeyup(e) {
    e.preventDefault()
    e.stopPropagation()

    const selected = this.resultsTarget.querySelectorAll(".selected")
    let current = null

    if (e.key == 'ArrowDown') {
      if (selected.length) {
        selected[0].classList.remove("selected")
      }

      if (!selected.length || selected == this.resultsTarget.lastChild) {
        current = this.resultsTarget.children[0]
      } else {
        current = selected[0].nextElementSibling
      }
    } else if (e.key == 'ArrowUp') {
      if (selected.length) {
        selected[0].classList.remove("selected")
      }

      if (!selected.length || selected == this.resultsTarget.firstChild) {
        current = this.resultsTarget.children[this.resultsTarget.children.length - 1]
      } else {
        current = selected[0].previousElementSibling
      }
    } else if (e.key == 'ArrowRight' || e.key == 'ArrowLeft') {
      e.preventDefault()
      e.stopPropagation()

      if (selected[0]) {
        const evt = document.createEvent('Events')
        evt.initEvent('click', true, false)
        selected[0].dispatchEvent(evt)
        return false
      }
    }

    if (current) {
      current.classList.add("selected")
    }
  }

  onInputFocus(e) {
    this.InputTarget.value = ""
    this.search(e)
  }

}
